/* eslint-disable no-unreachable */
import axios from "axios";
import { storage } from "./Storage";

// POST Request to call API
export const PostRequest = async (url, data) => {
  try {
    const res = await axios.post(url, data, {
      headers: {
        Accept: "application/json",
        "Authorization": storage?.fetch?.auth()
      },
    });
    if (res.status === 401) {
      storage.destory.auth()
      storage.destory.loggedinuser()
    }
    return res;
  } catch (err) {

  }
};

// PUT Request to call API
export const PutRequest = async (url, data) => {
  try {
    const res = await axios.put(url, data, {
      headers: {
        Accept: "multipart/form-data",
        "Content-Type": "multipart/form-data",
        "Authorization": storage?.fetch?.auth()
      },
    });
    return res;
  } catch (err) {

  }
};

// GET Request to call API
export const GetRequest = async (url, data) => {
  try {
    const res = await axios.get(url)

    return res;
  } catch (err) {

    return err.response
  }
};

// PATCH Request to call API
export const PatchRequest = async (url, data) => {
  try {
    const res = await axios.patch(url, data)
    return res;
  } catch (err) {
    return err.response
  }
};

// DELETE Request to call API
export const DeleteRequest = async (url, data) => {
  try {
    const res = await axios.delete(url, {
      data
    })
    return res;
  } catch (err) {
    return err.response
  }
};

export const Api = {
  PostRequest,
  GetRequest,
  PutRequest,
  PatchRequest,
  DeleteRequest
};
